import { BaseListComponent } from 'src/app/shared/components/base-list-component/base-list-component';
import { ToastrManager } from 'ng6-toastr-notifications';
import { AuthService } from './../../../shared/services/auth.service';
import { Component, Injector } from '@angular/core';
import { Subcategory } from '../models/subcategory.model';
import { SubcategoryService } from '../services/subcategory.service';

@Component({
  selector: 'ng-subcategory-list',
  templateUrl: 'subcategory-list.component.html'
})
export class SubcategoryListComponent extends BaseListComponent<Subcategory> {

   constructor(
    public subcategoyServ:SubcategoryService,
    public injector:Injector,
    public auth:AuthService,
    public toastr:ToastrManager,
  ){
    super(subcategoyServ, injector, 'subcategory', {editUrl:'/admin/settings/subcategory/edit', createUrl:'/admin/settings/subcategory/new'});
  }
 
  protected tableProprieties(): string[] {
    return [
        'Código',
        'Categoria',
        'Subcategoria',
    ]
  }

  protected initChildMethods(): void {}
  protected initChildProprieties(): void {}
  

}
